import {observer} from 'mobx-react-lite';
import {useStore} from '@/store/root-store';
import {Table} from '@/components/common-components/components';
import {ColumnsType} from 'antd/lib/table';
import {isNil} from 'lodash';
import {formatNumber} from '@/utils/number';
import {VerticalBar} from '@/components/common-components/components/vertical-bar/index';
import styled from 'styled-components';
import {CaretDownOutlined} from '@ant-design/icons';
import {Dropdown, Tooltip} from 'antd';
import {EmptyStateKeDetail} from './emptyStateKe';
import {getDomain, getSingleUrlParam, isPublicKeywordResearcherV2} from '@/utils/url';
import {useEffect, useState} from 'react';
import {Progress} from 'antd';
import {PublicPageBanner} from '../../ke-common-components/publicPageBanner';
import Link from 'next/link';
import {linkgraphDomains} from '@/utils/router';

export const GoogleAdsBuyTable = observer(() => {
  const {keywordResearcherV2: {keywordDetails: {getOrganicPaidHistoryData, loadingOrganicPaidHistoryDetails}}} = useStore('');
  // const router = useRouter();
  const countryCode = getSingleUrlParam('countryCode');
  const locationId = getSingleUrlParam('locationId');
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  const data = getOrganicPaidHistoryData?.paidRankings?.adsBuyRecommendations;
  const currentDomain = getDomain(window.location.hostname);
  const isWhiteLabelDomain = !linkgraphDomains.includes(currentDomain);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleWeightLabelBackGround = label=>{
    if (label?.toLowerCase()== 'good buy') {
      return 'rgba(31, 172, 71, 0.07)';
    } else if (label?.toLowerCase()== 'average' ||label?.toLowerCase()== 'bad buy') {
      return 'rgba(255, 133, 54, 0.07)';
    } else {
      return 'rgba(191, 225, 94, 0.1)';
    }
  };
  const handlelabelColor = label=>{
    if (label?.toLowerCase()== 'good buy') {
      return '#1FAC47';
    } else if (label?.toLowerCase()== 'average') {
      return '#FF8536';
    } else if (label?.toLowerCase()== 'bad buy') {
      return '#F44343';
    } else {
      return '#BFE15E';
    }
  };
  const getMenuforDropDown = data=>{
    return <WrapperDropDown>
      <FlexWrapper>

        <div>
          <FirstHeading>
        COMPETITOR
          </FirstHeading>
          {data?.matchingCompetitors?.map(item=>{
            return <>
              <a href={`https://${item}`} target='_blank' rel='noreferrer'> {item} </a><br/></>;
          })}
        </div>
        {/* <FirstHeading>POSITION</FirstHeading> */}
      </FlexWrapper>
    </WrapperDropDown>;
  };
  const columns: ColumnsType = [{
    title: () => <span>KEYWORD</span>,
    key: 'keyword',
    dataIndex: 'keyword',
    width: '100%',
    fixed: screenWidth >= 768 ? 'left' as 'left' : false,
    render: (_, data: any, index) =>
      <>
        <Link legacyBehavior shallow={true} href={data.keyword ? `/research/keyword-researcher/${'new'}/${data.keyword?.replaceAll(' ', '+')}?${locationId ? `locationId=${locationId}` : `countryCode=${countryCode ? countryCode : ''}`}` : ''} passHref>
          <a>
            <CellWrapperFirst blurred={index > 4 && ((isPublicKeywordResearcherV2() && isWhiteLabelDomain) ? false : isPublicKeywordResearcherV2())}>
              <KeywordWrapper >{data?.keyword ? data.keyword : ''}</KeywordWrapper>
            </CellWrapperFirst>
          </a>
        </Link>
      </>,
  },
  {
    title: () => <div>PURCHASE RATING</div>,
    key: 'purchaserating',
    dataIndex: 'purchaserating',
    align: 'left',
    width: 230,
    render: (_, data: any, index) => {
      return <>
        <FlexWrapperWeightLabel blurred={index > 4 && ((isPublicKeywordResearcherV2() && isWhiteLabelDomain) ? false : isPublicKeywordResearcherV2())}>
          <WeightLabelWrapper backgroundColor={handleWeightLabelBackGround(data?.weightLabel)}>
            <Dot color= {handlelabelColor(data?.weightLabel)}/>
            <WeightLabelName >{data?.weightLabel}</WeightLabelName>
          </WeightLabelWrapper>
          <div style={{width: '100px'}}>
            <Progress type='line'
              width={25}
              showInfo={false}
              strokeWidth={5}
              percent={data?.weight}
              trailColor='#E8E8E8'
              strokeColor={handlelabelColor(data?.weightLabel)}
            />
          </div>
        </FlexWrapperWeightLabel>
      </>;
    },
  },
  {
    title: () => <Tooltip title={<TooltipDescriptionWrapper>
      {`The average number of monthly searches for the analyzed keyword over the last 12 months. This is useful in determining whether or not a keyword is worth targeting from an SEO perspective.`}
    </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}>  <div>
        <span>MONTHLY</span><br/>
        <span>SEARCH VOLUME</span>
      </div></Tooltip>,
    key: 'searchVolume',
    dataIndex: 'searchVolume',
    align: 'right',
    width: 130,
    sorter: (a: any, b: any) => a?.searchVolume - b?.searchVolume,
    render: (_, data: any, index) => <CellWrapper blurred={index > 4 && ((isPublicKeywordResearcherV2() && isWhiteLabelDomain) ? false : isPublicKeywordResearcherV2())}>
      {!isNil(data?.searchVolume) ? formatNumber(data?.searchVolume) : '-'}</CellWrapper>,
  },
  //   {
  //     title: () => <Tooltip title={<TooltipDescriptionWrapper>
  //       {`The strength of your target's backlink profile compared to the other websites in our database on a 100-point logarithmic scale
  // `}      </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <div>
  //         <span>DOMAIN</span><br/>
  //         <span>STRENGTH</span>
  //       </div></Tooltip>,
  //     key: 'weight',
  //     dataIndex: 'weight',
  //     align: 'right',
  //     width: 100,
  //     sorter: (a: any, b: any) => a?.weight - b?.weight,
  //     render: (_, data: any) => <div style={{display: 'flex', alignItems: 'center', justifyContent: 'end'}}>
  //       {!isNil(data?.weight) ? formatNumber(data?.weight) : '-'}</div>,
  //   },
  {
    title: () =><Tooltip title={<TooltipDescriptionWrapper>
      {`The price advertisers pay per click to target this keyword in Google Ads campaigns.`}
    </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}>  <span>CPC</span></Tooltip>,
    key: 'cpc',
    dataIndex: 'cpc',
    align: 'right',
    width: 90,
    sorter: (a: any, b: any) => a?.cpc - b?.cpc,
    render: (_, data: any, index) => <CellWrapper blurred={index > 4 && ((isPublicKeywordResearcherV2() && isWhiteLabelDomain) ? false : isPublicKeywordResearcherV2())}>
      {!isNil(data?.cpc) ? `$${data?.cpc?.toFixed(0)}` : '-'}
      <VerticalBar
        cpc={data?.cpc}
        maxCpc={20}
      />
    </CellWrapper>,
  },
  {
    title: () => <div>
      <span>COMPETITORS</span><br/>
      <span>WHO BOUGHT</span>
    </div>,
    key: 'matchingCompetitors',
    dataIndex: 'matchingCompetitors',
    align: 'center',
    width: 130,
    render: (_, data: any, index) => {
      return <CellWrapper blurred={index > 4 && ((isPublicKeywordResearcherV2() && isWhiteLabelDomain) ? false : isPublicKeywordResearcherV2())}>
        <Dropdown overlay={getMenuforDropDown(data)} trigger={['click']}>
          <Wrapper>
            <div>
              {data?.matchingCompetitors?.length}
            </div>
            <div style={{paddingLeft: '10px'}}>
              <CaretDownOutlined />
            </div>

          </Wrapper>
        </Dropdown>
      </CellWrapper>;
    },
  },
  ];

  return (
    <div>
      {isPublicKeywordResearcherV2() && isWhiteLabelDomain ? ' ' : isPublicKeywordResearcherV2() && <BannerDiv><BannerContainer>
        <PublicPageBanner isInTable={true}/>
      </BannerContainer></BannerDiv>}
      <TableContainer>
        {loadingOrganicPaidHistoryDetails || data?.length ?
          <Table
            dataSource={data || []}
            columns={columns}
            pagination={false}
            loading={loadingOrganicPaidHistoryDetails}
            loadingRows={10}
            rowClassName={(_, index) => isPublicKeywordResearcherV2() && isWhiteLabelDomain ? '' : isPublicKeywordResearcherV2() && index > 4 && index !== 7 ? 'bluredRowStyle' : ''}
          /> :
          <EmptyStateKeDetail imgText={'/img/backgroundfasearch.svg'} icon={true} text={'Ads recommendations data is unavailable or missing.'} description = {'Data not found.'}/>

        }
      </TableContainer></div>
  );
});
const FlexWrapperWeightLabel = styled.div<{blurred?: boolean}>`
display: flex;
gap: 25px;
${p => p.blurred ? `filter: blur(10px);
    pointer-events: none;` : ''}
`;

const BannerDiv = styled.div`
  position: relative;
  width: 1px;
  margin: auto;
  left: -50px;
`;


const BannerContainer = styled.div`
   position: absolute;
  width: 690px;
  top: 358px;
  left: -290px;
  z-index: 9;
`;

const CellWrapperFirst = styled.div<{blurred?: boolean}>`
  ${p => p.blurred ? `filter: blur(10px);
    pointer-events: none;` : ''}
`;
const WeightLabelName = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #121212;
`;

const CellWrapper = styled.div<{blurred?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: end;
  ${p => p.blurred ? `filter: blur(10px);
    pointer-events: none;` : ''}
`;
const WeightLabelWrapper = styled.div<{backgroundColor: any}>`
border-radius: 6px;
width: fit-content;
padding: 0px 10px;
height: 32px;
display: flex;
align-items: center;
justify-content: center;
background: ${p=>p?.backgroundColor ? p?.backgroundColor : 'rgba(244, 67, 67, 0.07)'};
`;
const TableContainer = styled.div`
 padding-bottom: 0 !important;
 position: relative;
 .bluredRowStyle {
  filter: blur(10px);
  pointer-events: none;
 }

 .ant-table-body {
  overflow-y: auto !important;
  &::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }
}

table tr th {
  background-color: #fff;
}

.ant-table-content {
  border-radius: 0 !important;
}

.ant-table-column-sorters-with-tooltip:not(:first-child) {
  text-align: center;
}

table {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;

  th::before {
    width: 0 !important;
  }

  .ant-table-column-sorter {
    display: flex;
    padding-left: 3px !important;
  }

  .ant-table-column-sorters {
    display: inline-flex !important;
    padding: 5px !important;
  }

  tr td {
    &:first-child {
      padding-bottom: 0 !important;
      padding-top: 0 !important;
    }
  }

  .ant-table-tbody {
    tr:nth-child(even) {
      td {
        background: #fff !important;
        border-bottom: 1px solid #f4f4f4 !important;
        box-shadow: none;
        font-weight: 400;
        white-space: nowrap;
      }

      &:hover {
        td {
          background: #eef4fe !important;
        }

        button {
          background: #eef4fe !important;
          border: 0 !important;
          color: #2d6cca;
          font-weight: 500;
        }
      }
    }

    tr:nth-child(odd) {
      td {
        background: #fff;
        border-bottom: 1px solid #f4f4f4 !important;
        box-shadow: none;
        font-weight: 400;
        white-space: nowrap;
      }

      &:hover {
        td {
          background: #eef4fe !important;
        }

        button {
          background: #eef4fe !important;
          border: 0 !important;
          color: #2d6cca;
          font-weight: 500;
        }
      }
    }
  }

  .ant-table-thead {
    background: #f7f7f7 !important;

    th {
      background: #f7f7f7 !important;
      color: #121212 !important;
      font-size: 12px;
      font-weight: 600;
      line-height: 14px;
      padding: 0 !important;
    }

    .ant-table-cell-fix-left {
      text-align: left !important;

      &:first-child {
        border-bottom-left-radius: 8px !important;
        border-top-left-radius: 8px !important;
      }
    }

    th:first-child {
      background: #f7f7f7 !important;
      border-bottom-left-radius: 8px !important;
      border-top-left-radius: 8px !important;
      color: #121212;
      font-size: 12px;
      font-weight: 600;
    }

    th:nth-child(2) {
      background: #f7f7f7 !important;
      color: #121212;
      font-size: 12px;
      font-weight: 600;
    }

    th:last-child {
      background-color: #f7f7f7 !important;
      border-bottom-right-radius: 8px !important;
      border-top-right-radius: 8px !important;
      padding-left: 25px !important;
    }
  }

  .ant-table-cell-fix-left-last {
    text-align: left !important;
  }

  tr:first-child td {
    background: #fff !important;
  }

  tr:nth-child(even) td {
    background: #f9f9fb !important;
  }

  tr:nth-child(odd) td {
    background-color: #fff !important;
  }

  tr th {
    height: 50px !important;
    line-height: 22px;
    white-space: nowrap;
  }

  .ant-column-sorters {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  tr td {
    padding-bottom: 15px;
    padding-top: 15px;
    @media screen and (max-width: 520px) {
      padding-right: 20px !important;
    }
  }

  tr th:first-child,
  tr td:first-child {
    padding-left: 25px !important;
    padding-right: 25px !important;
  }

  tr th:last-child,
  tr td:last-child {
    padding-left: 25px !important;
    padding-right: 25px !important;
    text-align: center;
  }
}
`;

const Wrapper = styled.div`
margin-left: 10px;
  width: 74.88px;
  height: 32px;
  left: 1290px;
  top: 1461px;
  background: #F7F7F8;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 12px 8px;
  cursor: pointer;
`;
const WrapperDropDown = styled.div`
  width: 284px;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 6px 25px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding: 21px 15px 15px 15px;
`;
const Dot = styled.div<{color: string}>`
 width: 5px;
 height: 5px;
 border-radius: 5px;
 background-color: ${p => p.color};
 margin-right: 5px;
`;
const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FirstHeading = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #121212;
`;
const TooltipDescriptionWrapper = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #121212;
  padding: 5px;
`;
const KeywordWrapper = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #2D6CCA;
  cursor: pointer;
  &:hover { 
    text-decoration: underline;
  }
`;
